import { render, staticRenderFns } from "./formGroupTextArea.vue?vue&type=template&id=84fd1c1c"
import script from "./formGroupTextArea.vue?vue&type=script&lang=js"
export * from "./formGroupTextArea.vue?vue&type=script&lang=js"
import style0 from "./formGroupTextArea.vue?vue&type=style&index=0&id=84fd1c1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports